import React from "react";
import classNames from "classnames";

export default function ActionButton({
  children,
  variant = "primary",
  onClick,
  disabled,
  isFullScreen,
}) {
  return (
    <button
      className={classNames(`btn btn-${variant} w-100 mb-2`, {
        "btn-lg": isFullScreen,
      })}
      type="button"
      onClick={onClick}
      disabled={disabled}
    >
      {children}
    </button>
  );
}
